var _ellipse, _path, _path2, _path3, _path4, _rect, _rect2, _path5, _path6, _path7, _circle, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 163,
    viewBox: "0 0 180 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90,
    cy: 139.468,
    rx: 90,
    ry: 23,
    fill: "url(#paint0_radial_14287_145479)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.2174 32.968L20 79.5135V96.968H160V79.5135L144.783 32.968H35.2174Z",
    fill: "#CDCDCD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 4.46802C44 2.25888 45.7909 0.468018 48 0.468018H132C134.209 0.468018 136 2.25888 136 4.46802V82.468H44V4.46802Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38 50.7561C38 48.547 39.7909 46.7561 42 46.7561H138C140.209 46.7561 142 48.547 142 50.7561V104.756H38V50.7561Z",
    fill: "#F8F8F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 67.7561C32 65.547 33.7909 63.7561 36 63.7561H144C146.209 63.7561 148 65.547 148 67.7561V107.756H32V67.7561Z",
    fill: "#F8F8F8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 58.7561,
    width: 104,
    height: 5,
    fill: "url(#paint1_linear_14287_145479)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 77.7561,
    width: 116,
    height: 19,
    fill: "url(#paint2_linear_14287_145479)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.7251 79.968H20V135.968C20 138.177 21.7909 139.968 24 139.968H156C158.209 139.968 160 138.177 160 135.968V79.968H127.276C124.184 79.9713 118.717 80.1056 117.391 85.6822L115 95.8859H65L62.6082 85.6822C61.2828 80.1056 55.8166 79.9713 52.7251 79.968Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67 115.256C67 113.875 68.1193 112.756 69.5 112.756C70.8807 112.756 72 113.875 72 115.256V120.756H67V115.256Z",
    fill: "#DCDCDC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M108 115.256C108 113.875 109.119 112.756 110.5 112.756C111.881 112.756 113 113.875 113 115.256V120.756H108V115.256Z",
    fill: "#DCDCDC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 25.468,
    r: 16,
    fill: "#F8F8F8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M88.726 29.1097C88.6712 28.3655 88.7123 27.7498 88.8493 27.2627C88.9863 26.7621 89.1644 26.3426 89.3836 26.0043C89.6164 25.666 89.8699 25.3751 90.1438 25.1316C90.4178 24.888 90.6712 24.6512 90.9041 24.4212C91.1507 24.1912 91.3562 23.9341 91.5205 23.6499C91.6849 23.3658 91.7671 23.0139 91.7671 22.5945C91.7671 22.0668 91.637 21.627 91.3767 21.2752C91.1164 20.9099 90.6986 20.7272 90.1233 20.7272C89.5479 20.7272 89.0753 20.9234 88.7055 21.3158C88.3356 21.7082 88.1233 22.3103 88.0685 23.1222H85.5C85.5548 22.2291 85.7329 21.4782 86.0342 20.8693C86.3493 20.2604 86.726 19.7732 87.1644 19.4079C87.6164 19.0426 88.1096 18.7922 88.6438 18.6569C89.1781 18.5081 89.6986 18.4472 90.2055 18.4743C90.8082 18.5013 91.3699 18.6096 91.8904 18.799C92.4247 18.9749 92.8836 19.232 93.2671 19.5703C93.6507 19.895 93.9521 20.2942 94.1712 20.7678C94.3904 21.2414 94.5 21.7826 94.5 22.3915C94.5 23.0951 94.411 23.6634 94.2329 24.0964C94.0548 24.5294 93.8288 24.8948 93.5548 25.1925C93.2945 25.4766 93.0137 25.7269 92.7123 25.9434C92.411 26.1599 92.1301 26.4035 91.8699 26.6741C91.6233 26.9312 91.4178 27.2492 91.2534 27.628C91.089 28.0069 91.0205 28.5008 91.0479 29.1097H88.726ZM89.8973 34.468C89.363 34.468 88.9178 34.2853 88.5616 33.92C88.2055 33.5411 88.0274 33.0743 88.0274 32.5195C88.0274 31.9648 88.2055 31.5047 88.5616 31.1394C88.9178 30.7605 89.363 30.5711 89.8973 30.5711C90.4452 30.5711 90.8973 30.7605 91.2534 31.1394C91.6096 31.5047 91.7877 31.9648 91.7877 32.5195C91.7877 33.0743 91.6096 33.5411 91.2534 33.92C90.8973 34.2853 90.4452 34.468 89.8973 34.468Z",
    fill: "#CDCDCD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67 119.756C67 118.652 67.8954 117.756 69 117.756H111C112.105 117.756 113 118.652 113 119.756V120.756C113 121.861 112.105 122.756 111 122.756H69C67.8954 122.756 67 121.861 67 120.756V119.756Z",
    fill: "#F8F8F8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_14287_145479",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(90 138.989) rotate(90) scale(23 90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14287_145479",
    x1: 90,
    y1: 74.1728,
    x2: 90,
    y2: 58.7561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14287_145479",
    x1: 90,
    y1: 136.339,
    x2: 90,
    y2: 77.7561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/NotFound.1145439545c7c256bd60ef153e81f302.svg";
export { ForwardRef as ReactComponent };